// extracted by mini-css-extract-plugin
export default {"legendIndicator":"bha-z","legendNew":"cha-z"};